import {computed, onMounted, ref} from "@vue/composition-api";
import store from "@/store";
import {useRouter} from "@core/utils/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {useToast} from "vue-toastification/composition";

export const useStocksView = () => {
  const { router } = useRouter();
  const toast = useToast();

  const perPage = ref(5);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");

  const itemView = "grid-view";
  const itemViewOptions = [
    { icon: "GridIcon", value: "grid-view" },
    { icon: "ListIcon", value: "list-view" },
  ];

  // Filters params
  const filters = ref({
    q: "",
    categories: [],
    brands: [],
    page: 1,
    perPage: 5,
  });

  const filterOnStock = ref({ name: "Filtre stocks", slug: "all" });

  const filterOnStockOptions = computed(() => {
    return [
      {
        name: "Tous les Stocks",
        slug: "all"
      },
      ...store.getters["stock/all"],
    ];
  });

  const filterOptions = computed(() => {
    return store.getters["item/allProperties"];
  });

  // get products from store
  const products = computed({
    get: () => store.getters["storeManagement/products"],
    set: (val) => store.commit("storeManagement/SET_PRODUCTS_LIST", val),
  });

  // pagination data
  const dataMeta = computed(() => {
    const localItemsCount = products.value?.length ?? 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: localItemsCount,
    };
  });

  const fetchProducts = (...args) =>
      store.dispatch("storeManagement/fetchItems", ...args);

  const fetchProductsProperties = () => store.dispatch("item/fetchItemProperties", {
    props: ["categories", "brands"],
  });

  const fetchStocksList = () => store.dispatch("stock/allStocks", router.currentRoute.params.id);

  onMounted(() => {
    fetchProductsProperties();
    fetchStocksList();
  });

  const productAvailableInStock = (product) => {
    if (product.details === undefined) return false;
    return product.details?.available !== 0;
  };

  const showToast = (title, icon, variant) => {
    toast({
      component: ToastificationContent,
      props: {
        title: title,
        icon: icon,
        variant: variant,
      },
    });
  };

  return {
    itemView,
    itemViewOptions,
    // Filter
    filters,
    filterOptions,

    // Filter on stock
    filterOnStock,
    filterOnStockOptions,

    // data
    dataMeta,
    products,
    fetchProducts,
    productAvailableInStock,

    showToast,
  };
};




